function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import TextBlockParser from './text-block-parser';
import { DEFAULT_ALIGNMENT, BLOCK_TYPES } from '../constants';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { getResponsiveClasses } from '../../helpers/table';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';
export default class BlockParser {
  constructor(documentBuilder, config) {
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "textBlockParser", void 0);
    this.documentBuilder = documentBuilder;
    this.schema = documentBuilder.schema;
    this.textBlockParser = new TextBlockParser(documentBuilder, config);
  }
  handle(block, nextBlock) {
    switch (block.type) {
      case BLOCK_TYPES.ORDERED_NESTED_LIST:
      case BLOCK_TYPES.UNORDERED_NESTED_LIST:
        this.nestedList(block);
        break;
      case BLOCK_TYPES.PARAGRAPH:
      case BLOCK_TYPES.ORDERED_LIST:
      case BLOCK_TYPES.UNORDERED_LIST:
      case BLOCK_TYPES.HEADING:
      case BLOCK_TYPES.SUBHEADING:
      case BLOCK_TYPES.SUBHEADING3:
      case BLOCK_TYPES.SUBHEADING4:
      case BLOCK_TYPES.SMALL:
      case BLOCK_TYPES.CODE:
        this.textBlockParser.handle(block, nextBlock);
        break;
      case BLOCK_TYPES.HTML:
        this.html(block);
        break;
      case BLOCK_TYPES.HORIZONTAL_RULE:
        this.horizontalRule(block);
        break;
      case BLOCK_TYPES.IMAGE:
        this.image(block);
        break;
      case BLOCK_TYPES.IMAGE_TEXT:
        this.imageText(block);
        break;
      case BLOCK_TYPES.VIDEO:
        this.video(block);
        break;
      case BLOCK_TYPES.VIDEO_FILE:
        this.videoFile(block);
        break;
      case BLOCK_TYPES.AUDIO_FILE:
        this.audioFile(block);
        break;
      case BLOCK_TYPES.BUTTON:
        this.button(block);
        break;
      case BLOCK_TYPES.MESSENGER_CARD:
        this.messengerCard(block);
        break;
      case BLOCK_TYPES.TABLE:
        this.table(block);
        break;
      case BLOCK_TYPES.IF_ELSE_STATEMENT:
        this.ifElseStatement(block);
        break;
      case BLOCK_TYPES.TWITTER_FOLLOW_BUTTON:
        this.twitterFollowButton(block);
        break;
      case BLOCK_TYPES.FACEBOOK_LIKE_BUTTON:
        this.facebookLikeButton(block);
        break;
      case BLOCK_TYPES.SOCIAL:
        this.social(block);
        break;
      case BLOCK_TYPES.SPACER:
        this.spacer(block);
        break;
      case BLOCK_TYPES.CALLOUT:
        this.callout(block);
        break;
      case BLOCK_TYPES.COLLAPSIBLE_SECTION:
        this.collapsibleSection(block);
        break;
      case BLOCK_TYPES.UNSUPPORTED_ELEMENT:
        this.unsupportedElement(block);
        break;
    }
  }
  table(block) {
    let spec = this.schema.nodes.table;
    if (spec) {
      let attrs = {
        responsive: block.responsive || false,
        container: block.container || false,
        sectionType: block.sectionType
      };
      if (typeof block.stacked === 'boolean') {
        attrs.stacked = block.stacked;
      }
      let paddingAttrs = this.getPaddingAttrs(block);
      attrs = {
        ...attrs,
        backgroundColor: this.addBackgroundColor(block) || '',
        borderRadius: this.addBorderRadius(block) || '',
        ...paddingAttrs
      };
      this.documentBuilder.openNode(spec, attrs);
      block.rows.forEach(row => this.tableRow(row, attrs));
      this.documentBuilder.closeNode();
    }
  }
  tableRow(row, attrs) {
    let spec = this.schema.nodes.tableRow;
    if (spec) {
      let cellAttrs = attrs.responsive ? {
        responsiveClasses: getResponsiveClasses(row.cells.length)
      } : {};
      cellAttrs = attrs.container ? {
        ...cellAttrs,
        container: true
      } : cellAttrs;
      this.documentBuilder.openNode(spec, {});
      row.cells.forEach(cell => this.tableCell(cell, cellAttrs));
      this.documentBuilder.closeNode();
    }
  }
  tableCell(cell, attrs) {
    let spec = this.schema.nodes.tableCell;
    if (spec) {
      if (attrs.container) {
        let paddingAttrs = this.getPaddingAttrs(cell);
        attrs = {
          ...attrs,
          ...paddingAttrs
        };
      }
      if (!attrs.container && !attrs.responsive) {
        attrs = {
          ...attrs,
          backgroundColor: this.addBackgroundColor(cell) || ''
        };
      }
      if (cell.displayWidth) {
        attrs = {
          ...attrs,
          colwidth: [cell.displayWidth]
        };
      }
      this.documentBuilder.openNode(spec, attrs);
      if (attrs.container && cell.content.length === 0 && this.schema.nodes.placeholder) {
        this.placeholder();
      }
      cell.content.forEach(block => this.handle(block));
      this.documentBuilder.closeNode();
    }
  }
  social(block) {
    let spec = this.schema.nodes.social;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        alignment: this.alignmentClass(block),
        items: block.items
      });
      this.documentBuilder.closeNode();
    }
  }
  spacer(block) {
    let spec = this.schema.nodes.spacer;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        height: block.height
      });
      this.documentBuilder.closeNode();
    }
  }
  callout(block) {
    let spec = this.schema.nodes.callout;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        type: block.type,
        backgroundColor: this.addBackgroundColor(block) || '',
        borderColor: this.addBorderColor(block) || ''
      });
      block.content.forEach(block => this.handle(block));
      this.documentBuilder.closeNode();
    }
  }
  unsupportedElement(block) {
    let spec = this.schema.nodes.unsupportedElement;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        type: block.type,
        unsupportedTypeName: block.unsupportedTypeName,
        text: block.text
      });
      this.documentBuilder.closeNode();
    }
  }
  placeholder(attrs = {}) {
    this.documentBuilder.openNode(this.schema.nodes.placeholder, attrs);
    this.documentBuilder.closeNode();
  }
  nestedList(block) {
    let spec = this.schema.nodes[block.type];
    if (spec) {
      this.documentBuilder.openNode(spec, {});
      block.items.forEach(item => this.nestedListItem(item));
      this.documentBuilder.closeNode();
    }
  }
  nestedListItem(item) {
    let spec = this.schema.nodes.nestedListItem;
    if (spec) {
      this.documentBuilder.openNode(spec, {});
      item.content.forEach(block => this.handle(block));
      this.documentBuilder.closeNode();
    }
  }
  ifElseStatement(block) {
    let spec = this.schema.nodes.ifElseStatement;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        predicatesBlocksPairs: block.predicatesBlocksPairs,
        fallbackBlocks: block.fallbackBlocks
      });
      this.documentBuilder.closeNode();
    }
  }
  twitterFollowButton(block) {
    let spec = this.schema.nodes.twitterFollowButton;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        username: block.username
      });
      this.documentBuilder.closeNode();
    }
  }
  facebookLikeButton(block) {
    let spec = this.schema.nodes.facebookLikeButton;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        url: block.url
      });
      this.documentBuilder.closeNode();
    }
  }
  image(block) {
    let spec = this.schema.nodes.image;
    if (spec) {
      // Validate URL - handle missing, null, undefined, or empty string URLs
      let url = block.url;
      let isValidUrl = url && typeof url === 'string' && url.trim() !== '';

      // Create node attributes with proper validation
      let attrs = {
        // Use placeholder if URL is invalid, otherwise use the original URL
        src: isValidUrl ? url : assetUrl('/@intercom/composer-ember/failed-image-upload.svg'),
        linkUrl: block.linkUrl,
        text: block.text,
        width: block.width,
        displayWidth: block.displayWidth,
        height: block.height,
        alignment: this.alignmentClass(block)
      };
      this.documentBuilder.openNode(spec, attrs);
      this.documentBuilder.closeNode();
    }
  }
  imageText(block) {
    let spec = this.schema.nodes.imageText;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        imageUrl: block.imageUrl,
        title: block.title,
        text: block.text
      });
      this.documentBuilder.closeNode();
    }
  }
  video(block) {
    let spec = this.schema.nodes.video;
    if (spec) {
      let id = 'videoId' in block ? block.videoId : block.id;
      this.documentBuilder.openNode(spec, {
        type: block.type,
        provider: block.provider,
        id
      });
      this.documentBuilder.closeNode();
    }
  }
  videoFile(block) {
    let spec = this.schema.nodes.videoFile;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        type: block.type,
        thumbnailUrl: block.thumbnailUrl,
        url: block.url,
        captions: block.captions
      });
      this.documentBuilder.closeNode();
    }
  }
  audioFile(block) {
    let spec = this.schema.nodes.audioFile;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        type: block.type,
        url: block.url
      });
      this.documentBuilder.closeNode();
    }
  }
  button(block) {
    let spec = this.schema.nodes.button;
    let text = this.unescapeExpression(block.text);
    if (spec) {
      let paddingAttrs = this.getPaddingAttrs(block);
      this.documentBuilder.openNode(spec, {
        type: block.type,
        linkUrl: block.linkUrl,
        buttonStyle: block.buttonStyle || 'solid',
        alignment: this.alignmentClass(block),
        fontFamily: this.addFontFamily(block) || '',
        fontColor: this.addFontColor(block) || '',
        backgroundColor: this.addBackgroundColor(block) || '',
        ...paddingAttrs,
        borderRadius: this.addBorderRadius(block) || '',
        text
      });
      this.documentBuilder.closeNode();
    }
  }
  unescapeExpression(text) {
    let div = document.createElement('div');
    div.innerHTML = sanitizeHtml(text);
    return div.textContent || '';
  }
  horizontalRule(block) {
    let spec = this.schema.nodes.horizontalRule;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        type: block.type,
        text: block?.text,
        width: block?.width || '',
        borderColor: this.addBorderColor(block) || '',
        borderWidth: this.addBorderWidth(block) || '',
        borderStyle: this.addBorderStyle(block) || ''
      });
      this.documentBuilder.closeNode();
    }
  }
  collapsibleSection(block) {
    let spec = this.schema.nodes.collapsibleSection;
    if (!spec) {
      return;
    }
    this.documentBuilder.openNode(spec, {});
    this.collapsibleSectionSummary(block);
    this.collapsibleSectionContent(block);
    this.documentBuilder.closeNode();
  }
  collapsibleSectionSummary(block) {
    let spec = this.schema.nodes.collapsibleSectionSummary;
    if (spec) {
      this.documentBuilder.openNode(spec, {});
      this.handle(block.summary);
      this.documentBuilder.closeNode();
    }
  }
  collapsibleSectionContent(block) {
    let spec = this.schema.nodes.collapsibleSectionContent;
    if (spec) {
      this.documentBuilder.openNode(spec, {});
      block.content.forEach(block => this.handle(block));
      this.documentBuilder.closeNode();
    }
  }
  html(block) {
    let spec = this.schema.nodes.html;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        content: block.content
      });
      this.documentBuilder.closeNode();
    }
  }
  messengerCard(block) {
    let spec = this.schema.nodes.messengerCard;
    if (spec) {
      this.documentBuilder.openNode(spec, {
        canvas: block.canvas,
        text: block.text,
        messenger_app_id: block.messenger_app_id,
        uri: block.uri
      });
      this.documentBuilder.closeNode();
    }
  }
  alignmentClass(block) {
    if (!block.align) {
      return DEFAULT_ALIGNMENT;
    }
    return block.align;
  }
  addFontFamily(block) {
    return block.style?.fontFamily;
  }
  addFontColor(block) {
    return block.style?.fontColor;
  }
  addBackgroundColor(block) {
    return block.style?.backgroundColor;
  }
  addBorderColor(block) {
    return block.style?.borderColor;
  }
  addBorderStyle(block) {
    return block.style?.borderStyle;
  }
  addBorderWidth(block) {
    return block.style?.borderWidth;
  }
  getPaddingAttrs(block) {
    return {
      paddingTop: block.style?.paddingTop || '',
      paddingBottom: block.style?.paddingBottom || '',
      paddingLeft: block.style?.paddingLeft || '',
      paddingRight: block.style?.paddingRight || ''
    };
  }
  addBorderRadius(block) {
    return block.style?.borderRadius;
  }
}